import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M3.3 6.7C2.9 6.3 2.9 5.7 3.3 5.3C3.7 4.9 4.3 4.9 4.7 5.3L8 8.6 11.3 5.3C11.7 4.9 12.3 4.9 12.7 5.3C13.1 5.7 13.1 6.3 12.7 6.7L8.7 10.7C8.3 11.1 7.7 11.1 7.3 10.7L3.3 6.7Z" />,
  'ArrowDown',
);
